const TECH_COLORS: [string, string][] = [
  // Order matters: more specific patterns first
  ['angular js', '#B52E31'],
  ['angular', '#DD0031'],
  ['react testing library', '#E45649'],
  ['react native', '#61DAFB'],
  ['react.js', '#61DAFB'],
  ['react', '#61DAFB'],
  ['next.js', '#FFFFFF'],
  ['styled-components', '#DB7093'],
  ['styled components', '#DB7093'],
  ['javascript', '#F7DF1E'],
  ['java', '#ED8B00'],
  ['node.js', '#339933'],
  ['spring boot', '#6DB33F'],
  ['spring', '#6DB33F'],
  ['typescript', '#3178C6'],
  ['yarn', '#2C8EBB'],
  ['jest', '#C21325'],
  ['cypress', '#04C38E'],
  ['storybook', '#FF4785'],
  ['emotion', '#C43BAD'],
  ['mongodb', '#47A248'],
  ['mysql', '#4479A1'],
  ['postgis', '#4B96CC'],
  ['postgresql', '#336791'],
  ['oracle', '#F80000'],
  ['hibernate', '#BCAE79'],
  ['sequelize', '#52B0E7'],
  ['mongoose', '#AA3300'],
  ['python', '#3776AB'],
  ['perl', '#7B87C9'],
  ['redux', '#764ABC'],
  ['jenkins', '#D33833'],
  ['kafka', '#D0D0D0'],
  ['ionic', '#3880FF'],
  ['expo', '#ECEDEE'],
  ['cordova', '#4CC2E5'],
  ['html5', '#E34F26'],
  ['html', '#E34F26'],
  ['css3', '#264DE4'],
  ['css', '#264DE4'],
  ['arduino', '#00979D'],
  ['cucumber', '#23D96C'],
  ['mocha', '#8D6748'],
  ['maven', '#C71A36'],
  ['litelement', '#324FFF'],
  ['express', '#EEEEEE'],
  ['jquery', '#0769AD'],
  ['webdriverio', '#EA5906'],
  ['sonarqube', '#4E9BCD'],
  ['msw', '#FF6A33'],
  ['karma', '#CE1A2E'],
  ['struts', '#D64B00'],
  ['nx', '#0097D7'],
  ['gitlab', '#FC6D26'],
  ['github', '#2088FF'],
  ['catalyst', '#B31B1B'],
  ['socket.io', '#25C2A0'],
]

export function getTechColor(text: string): string | undefined {
  const lower = text.toLowerCase()
  return TECH_COLORS.find(([key]) => lower.includes(key))?.[1]
}
